
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import {
  Form,
  FormItem,
  Input,
  Select,
  Option,
} from 'element-ui';
import api from '@/api/asset';
import Util from '@/libs/util';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Select,
    Option,
  },
})
export default class SearchForm extends Vue {
  @State((state => state.asset.category.listFlag)) listFlag!: boolean;

  @Prop() title!: string;

  private form: any = {
    title: '',
    categoryId: '',
  };

  private options: { [key: string]: Array<object> } = {
    categoryIdOpts: [],
  };

  public $refs!: {
    form: Form,
  };

  created() {
    this.getCategoryList();
  }

  setTitle(val: string) {
    this.form.title = val;
  }

  getFormData() {
    return {
      title: this.form.title,
      categoryId: this.form.categoryId,
    };
  }

  getCategoryList() {
    api.getCategoryList().then((res: any) => {
      this.options.categoryIdOpts = res;
    });
  }

  /**
   * @author terry
   * @desc 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
    this.options.cidOpts = [];
  }

  @Watch('listFlag')
  watchListFlag() {
    this.getCategoryList();
  }
}
